export * from "@auth/core/providers/google";
export { default } from "@auth/core/providers/google";
